<template>
    <div class="about-view">
        <div class="banner-view" />
        <div style="display:flex;padding:0 360px;margin-top: 42px;">
			<main class="main-content cursor">
				<div class="card " v-for="item in items" :key="item.id"   :class="{ card_text: activeId == item.id }"
      @click="activeId = item.id;active_name=item.name;manualList()" style="width:240px;display:flex;height:56px;font-weight: bold;">
					<img :src="item.image" style="width:20px;height:22px;margin-top: 17px;margin-left: 21px;" />
					<div style="font-size:14px;margin-left: 12px;width: 70px;height: 12px;margin-top: 22px;">{{ item.name }}</div>
				</div>
			</main>
        <div class="management-functions" style="display:table-column;">
            <div class="function-card cursor" @click="details(functionItem)" v-for="functionItem in functionItems" :key="functionItem.id">
				<div style="display: flex;float: left;width: 100px;height: 100px;">
                <img :src="functionItem.image" alt="" style="margin-top: 29px;margin-left: 13px;"/>
				</div>
				<div style="display: flex;float: left;width: 700px;height: 100%;">
					<div style="display: table-column;">
						<div style="display: flex;">
							<span class="cursor_hover" style="font-size: 18px;color: #333333;margin-top: 32px;font-weight: bold;">
							{{ functionItem.name }}
							</span>
							<img v-if="functionItem.from_type_list.indexOf('2') !== -1" src="../assets/manual/iphone.png" style="width:18px;height:18px;margin-top: 35px;margin-left: 12px;" />
							<img v-if="functionItem.from_type_list.indexOf('1') !== -1" src="../assets/manual/and.png" style="width:18px;height:18px;margin-top: 35px;margin-left: 12px;" />
							<img v-if="functionItem.from_type_list.indexOf('3') !== -1" src="../assets/manual/bg-ie-browser.png" style="width:18px;height:18px;margin-top: 35px;margin-left: 12px;" />
						</div>
						<div><span style="color:#666666;font-size:14px;">{{ functionItem.describe }}</span></div>
					</div>
				
				</div>
				<div>
					<img  src="../assets/manual/youjt-icon.png" style="width:24px;height:24px;float:right;margin-top: 44px;margin-right: 24px;" />
				</div>
				
            </div>
			<div style="margin-top: 31px;"></div>
        </div>
		</div>
    </div>
</template>

<script>
export default {
    name: 'AboutView',
    data() {
        return {
            items: [
                // { id: 1, title: '管理员手册',  link: '#',icon: require('@/assets/logo.png') },
                // { id: 2, title: '员工手册', link: '#',icon: require('@/assets/logo.png') },
                // 添加更多数据...
            ],
            functionItems: [
                // { id: 1, title: '创建企业/组织', description: '极简流程，快速创建', icon: require('@/assets/logo.png'), link: '#' },
                // { id: 2, title: '创建项目部门', description: '快速配置项目部门', icon: require('@/assets/logo.png'), link: '#' },
                // { id: 3, title: '添加企业/组织成员', description: '便捷添加人，快速连接链', icon: require('@/assets/logo.png'), link: '#' },
                // { id: 4, title: '企业/组织通讯录', description: '统一&高效管理通讯录', icon: require('@/assets/logo.png'), link: '#' },
                // { id: 5, title: '成员权限', description: '精细权限控制', icon: require('@/assets/logo.png'), link: '#' },
                // { id: 6, title: '应用设置', description: '灵活配置应用', icon: require('@/assets/logo.png'), link: '#' },
                // { id: 7, title: '客服&帮助', description: '提供帮助，访问帮助中心', icon: require('@/assets/logo.png'), link: '#' },
            ],
			activeId:0,
			active_name:""
        };
    },	
	created() {
		const activeId = this.$route.query.activeId;
		const active_name = this.$route.query.active_name;
		if(activeId){
			this.activeId=activeId;
			this.active_name=decodeURI(active_name);
		}
		
	},
	mounted() {
		this.manualType();
	},
	methods: {
		async manualType() {
			const response = await fetch(this.$apiBaseUrl+"/api/website/manual_type");
			const data = await response.json();
			this.items=data.data
			if(data.data&&this.activeId==0){
				this.activeId=data.data[0].id;
				this.active_name=data.data[0].name;
			}
			this.manualList();
		},
		async manualList() {
			const response = await fetch(this.$apiBaseUrl+"/api/website/manual_list",{  
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: 'manual_type_id=' + this.activeId
			});
			const data = await response.json();
			console.log(data.data)
			this.functionItems=data.data
			
		},
		details(item){
			this.$router.push("/manualde?id="+item.id+"&active_name="+encodeURI(this.active_name)+"&activeId="+this.activeId);
		}
	}      
};
</script>

<style lang="scss" scoped>
.about-view {
	.cursor{
		cursor:pointer
	}
	.cursor_hover:hover{
		color: #007BD3 !important;
	}
    display: flex;
    flex-direction: column;
    align-items: center;
	.card{color:#555555;}
	.card_text{background: #EBF7FF;border-radius: 10px;color: #007BD3;}
    .management-functions {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
		min-height: 800px;
        .function-card {
			width: 940px;
			height: 112px;
         
            // border-radius: 8px;
			border: none; /* 先取消所有边框 */
			border-bottom: 1px solid #ddd; /* 然后只设置下边框 */
            img {
                width: 50px;
                height: 50px;
                margin-bottom: 10px;
            }
            h4 {
                font-size: 16px;
                margin: 10px 0;
            }

        }
    }
}
</style>